export function getCurrentYear(): string {
  const date = new Date()

  return date.getFullYear().toString()
}
